import NavigationSider from '@hellodarwin/app-core/lib/layouts/navigation';
import { NavigationLink } from '@hellodarwin/core/lib/features/entities';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Accueil from '@hellodarwin/icons/dist/icons/Accueil';
import ArtificialIntelligence from '@hellodarwin/icons/dist/icons/ArtificialIntelligence';
import DeploymentUnit from '@hellodarwin/icons/dist/icons/DeploymentUnit';
import Employees from '@hellodarwin/icons/dist/icons/Employees';
import Help from '@hellodarwin/icons/dist/icons/Help';
import Language from '@hellodarwin/icons/dist/icons/Language';
import Notifications from '@hellodarwin/icons/dist/icons/Notifications';
import Search from '@hellodarwin/icons/dist/icons/Search';
import User from '@hellodarwin/icons/dist/icons/User';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../app/app-hooks';
import { selectProfile } from '../features/api/slices/profile-slice';

const ExpertNavigation = () => {
  const profile = useAppSelector(selectProfile);
  const { t } = useTranslation();
  const { t: hdT } = useTranslations();

  const links = useMemo<NavigationLink[]>(
    () => [
      {
        pathname: '/dashboard',
        label: t('navigation.dashboard'),
        Icon: Accueil,
      },
      {
        pathname: '/grant-profiles',
        label: hdT('grantProfiles|title'),
        Icon: Employees,
      },
      {
        pathname: '/funding-explorer',
        label: hdT('navigation|fundingExplorer2'),
        Icon: Search,
      },
      {
        pathname: '/assistant',
        label: hdT('navigation|assistant'),
        Icon: ArtificialIntelligence,
      },
      {
        pathname: '/funding-intelligence',
        label: hdT('navigation|fundingIntelligence'),
        Icon: Language,
      },
      {
        pathname: '/alerts',
        label: hdT('navigation|alerts'),
        Icon: Notifications,
      },
      {
        pathname: '/ai-integration',
        label: hdT('navigation|aiIntegration'),
        Icon: DeploymentUnit,
      },
      {
        pathname: '/faq',
        label: hdT('navigation|support'),
        Icon: Help,
        subLinks: [
          {
            pathname: '/resources',
            label: t('resource|resources'),
          },
          {
            pathname: '/faq',
            label: hdT('navigation|faq'),
          },
          {
            pathname: '/contact-us',
            label: hdT('navigation|contactUs'),
          },
        ],
      },
    ],
    [hdT, t],
  );

  const userLinks = useMemo<NavigationLink[]>(
    () => [
      {
        pathname: '/profile/contact',
        label: t('navigation.preferences'),
        Icon: User,
      },
    ],
    [t],
  );

  return (
    <NavigationSider
      links={links}
      app="client"
      userLinks={userLinks}
      profile={profile}
      defaultOpen
      showPremiumStatus={false}
    />
  );
};

export default ExpertNavigation;
